import dayjs from "dayjs";
import { BRAND } from "../../types";
import { stripHtml } from "@/utils/format";

/** 格式化日期：2026-05-01 → 5月1日 */
function fmtDate(date?: string): string {
  if (!date) return "";
  const d = dayjs(date);
  return d.isValid() ? d.format("M月D日") : date;
}

/** 从地址中提取城市名：四川省成都市双流区... → 成都市 */
function extractCity(address: string): string {
  const match = address.match(/[^省]+?市|[^省]+?(自治州|地区)|^[^区]+$/);
  return (match?.[0] || address).replace(/[县区].*$/, "").trim();
}

interface TripSummaryProps {
  /** 行程摘要文字 */
  spec: string;
  /** 取车地点 */
  pickupLocation?: string;
  /** 还车地点 */
  returnLocation?: string;
  /** 取车日期 */
  pickupDate?: string;
  /** 还车日期 */
  returnDate?: string;
  /** 租赁天数 */
  rentDays?: number;
}

export function TripSummary({ spec, pickupLocation, returnLocation, pickupDate, returnDate, rentDays }: TripSummaryProps) {
  // 清洗后端字段里夹带的 HTML 标签
  const safePickup = stripHtml(pickupLocation);
  const safeReturn = stripHtml(returnLocation);
  const locText = safePickup && safeReturn
    ? `${extractCity(safePickup)} → ${extractCity(safeReturn)}`
    : (spec || "行程信息");
  const dateText = pickupDate && returnDate
    ? `${fmtDate(pickupDate)} ~ ${fmtDate(returnDate)}`
    : (pickupDate ? fmtDate(pickupDate) : "待确认");

  return (
    <div
      className="rounded-2xl p-4 flex items-center justify-between"
      style={{ background: "linear-gradient(135deg, #FFF7ED 0%, #FFF0F5 100%)" }}
    >
      <div className="flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: "rgba(249,115,22,0.12)" }}
        >
          <i className="ri-map-pin-2-line" style={{ color: BRAND, fontSize: 18 }} />
        </div>
        <div>
          <div className="text-sm font-bold text-gray-900">{locText}</div>
          <div className="text-xs text-gray-500 mt-0.5">
            {dateText}
            {rentDays != null && rentDays > 0 && ` · 共 ${rentDays} 天`}
          </div>
        </div>
      </div>
      {rentDays != null && rentDays > 0 && (
        <div
          className="text-xs font-bold px-2.5 py-1 rounded-full flex-shrink-0"
          style={{ background: "#FFFDF8", color: BRAND }}
        >
          {rentDays}天
        </div>
      )}
    </div>
  );
}
